var map = {
	"./-1.png": "5e6d",
	"./-2.png": "1bab",
	"./-3.png": "a028",
	"./0.05.png": "fef3",
	"./0.1.png": "75ff",
	"./0.25.png": "4b91",
	"./0.252.png": "2bc3",
	"./0.5.png": "9a39",
	"./1.png": "ba3d",
	"./10.png": "08fb",
	"./100.png": "5a37",
	"./19.png": "2ddd",
	"./192.png": "b5b74",
	"./2.png": "4dac",
	"./20.png": "263f",
	"./200.png": "1af3",
	"./5.png": "72c4",
	"./50.png": "e0f3",
	"./cartao.png": "910b",
	"./pix.png": "e2f6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f519";